import _ from 'lodash';

export default _.kebabCase;
